import React from 'react';
import styled from 'styled-components';
import Icon from '@components/dataDisplay/Icons/Icon';

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
`;

type Props = {
  count?: number;
  onClick?: () => void;
};

function CommentIcon({ onClick, count }: Props) {
  return (
    <Wrapper onClick={onClick}>
      <Icon name="TalkF14" color="var(--subTextColor)" />
      <div>{count}</div>
    </Wrapper>
  );
}

export default CommentIcon;
